type ToastDismissListener = () => void;

const listeners = new Set<ToastDismissListener>();

/**
 * Closes every toast currently on screen. Call this from anything that takes the
 * screen over from a toast — a header or lower-nav menu, a modal, or a drawer —
 * so the toast does not sit on top of the new surface (SPR-2863).
 */
export function dismissAllToasts(): void {
  listeners.forEach((listener) => listener());
}

export function subscribeToToastDismiss(listener: ToastDismissListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
